import useApi from "./useApi";

export default function useResetPassword() {
  const { post } = useApi();
  // This returns a mutation for /reset-password
  return post("/reset-password");
} 